export var TooltipTypes = {
  COINS: 'coinBar',
  XP: 'xpBar',
  TIER: 'tierBar',
  TIER_COMING_SOON: 'tierComingSoon',
  LOYALTY: 'loyaltyBar',
  FTUE: 'ftue',
  MISSIONS: 'missions',
  REWARD_CENTER: 'rewardCenter',
  LINKING_ACCOUNT: 'linkingAccount',
  EVENTS: 'events'
};